export default "__VITE_ASSET__BBArGcuk__"